import React, { useState, useEffect, useContext } from 'react';
import { QrCode } from '@mui/icons-material';
import Logout from '@mui/icons-material/Logout';
import { SvgIcon, Grid, Divider } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useHistory } from 'react-router-dom';
import { poppins600 } from 'theme/common.style';
import QrCodeGenerator from './QrCodeGenerator';
import { BasicModal } from 'component/SolicitorModal/SolicitorModal';
import { useParams } from 'react-router-dom';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { datacontextsoli } from 'modules/private/BuyerSolicitor/BuyerSolicitor';

export default function AccountMenu(props) {
  const { footer, opensolicitor, setOpensolicitor, setOpenprofile } = props;
  const params = useParams();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openGen, setOpenGen] = React.useState(false);
  const [colseAccountItem, setColseAccountItem] = React.useState(true);
  const data1 = localStorage.getItem('userDetail');
  const [userDetail, setUserDetail] = useState(JSON.parse(data1));
  const openAcc = Boolean(anchorEl);
  const history = useHistory();
  const dataType = userDetail?.userType;
  const contextValue = useContext(
    dataType != 'Solicitor' ? datacontext : datacontextsoli
  );

  const setShowMessage = contextValue?.setShowMessage;

  useEffect(() => {
    const handleProfileUpdate = () => {
      const updatedData = localStorage.getItem('userDetail');
      if (updatedData) {
        setUserDetail(JSON.parse(updatedData));
      }
    };

    window.addEventListener('userProfileUpdated', handleProfileUpdate);
    return () => {
      window.removeEventListener('userProfileUpdated', handleProfileUpdate);
    };
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleOpens = () => {
    if (dataType != 'Solicitor') {
      history.push('/ProfileSetting');
    } else {
      setOpenprofile(true);
    }
  };
  React.useEffect(() => {
    setOpenGen(openGen);
  }, [openGen]);

  React.useEffect(() => {
    if (opensolicitor) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [opensolicitor]);

  let propertyId = window.location.pathname.split('/');
  propertyId =
    propertyId[propertyId.length - 1] != 'dashboard'
      ? propertyId[propertyId.length - 1]
      : 0;
  let CheckSolicitor = 'no';
  if (userDetail?.primaryUserType !== 'Agent') {
    const dataset = localStorage.getItem('buyerSolicitorDetails');
    const buyerSolicitorDetails = dataset ? JSON.parse(dataset) : null;
    if (propertyId == 0) {
      CheckSolicitor = 'no';
    } else {
      if (buyerSolicitorDetails?.length > 0) {
        buyerSolicitorDetails?.map((item) => {
          if (item?.propertyId == propertyId) {
            CheckSolicitor = 'yes';
          }
        });
      }
    }
  }

  const AddUser = () => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 45 35"
        fill="rgba(0, 0, 0, 0.54)"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.5597 3.10742C10.3925 3.10742 7.04636 6.4531 7.04636 10.6207C7.04636 14.7874 10.393 18.134 14.5597 18.134C18.7273 18.134 22.073 14.7878 22.073 10.6207C22.073 6.45264 18.7277 3.10742 14.5597 3.10742ZM14.5606 5.22635C17.5582 5.22635 19.9547 7.62277 19.9547 10.6204C19.9547 13.6172 17.5577 16.0145 14.5606 16.0145C11.5643 16.0145 9.16647 13.6167 9.16647 10.6204C9.16647 7.62329 11.5638 5.22635 14.5606 5.22635ZM14.5584 20.7054C7.45193 20.7054 3.42969 22.0539 3.42969 25.8748C3.42969 29.7 7.46978 31.074 14.5584 31.074L15.4675 31.0662C22.0053 30.952 25.687 29.5584 25.687 25.9045C25.687 22.1625 21.8207 20.7663 15.0163 20.7073L14.5584 20.7054ZM14.5593 22.8243C20.4951 22.8243 23.5687 23.8696 23.5687 25.9042C23.5687 27.9263 20.5026 28.9545 14.5593 28.9545C8.6234 28.9545 5.54979 27.9092 5.54979 25.8746C5.54979 23.9063 8.45079 22.8806 14.0835 22.8266L14.5593 22.8243ZM27.7358 11.4696C28.2723 11.4696 28.7156 11.8682 28.7857 12.3854L28.7954 12.5292V14.3021H30.6244C31.2096 14.3021 31.684 14.7765 31.684 15.3617C31.684 15.8982 31.2854 16.3415 30.7682 16.4117L30.6244 16.4213H28.7954V18.1946C28.7954 18.7798 28.321 19.2542 27.7358 19.2542C27.1994 19.2542 26.756 18.8555 26.6859 18.3384L26.6762 18.1946V16.4213H24.846C24.2608 16.4213 23.7864 15.9469 23.7864 15.3617C23.7864 14.8253 24.1851 14.382 24.7023 14.3118L24.846 14.3021H26.6762V12.5292C26.6762 11.944 27.1506 11.4696 27.7358 11.4696Z"
          fill="rgba(0, 0, 0, 0.54)"
        />
      </svg>
    );
  };

  const [open, setOpen] = React.useState(false);

  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <React.Fragment>
      {!footer && (
        <Box
          sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}
        >
          <Tooltip
            title={
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontSize: '14px',
                }}
              >
                Account settings
              </Typography>
            }
          >
            <IconButton
              onClick={handleClick}
              size="small"
              aria-controls={openAcc ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openAcc ? 'true' : undefined}
              sx={{ padding: '0px' }}
            >
              {userDetail?.profileImage == '' ||
              userDetail?.profileImage == null ? (
                <Avatar
                  sx={{
                    width: 32,
                    height: 33,
                    fontFamily: 'poppins',
                    borderRadius: '6px',
                    fontSize: '15px',
                    backgroundColor: '#666666',
                  }}
                >
                  {userDetail?.userName?.charAt(0)?.toUpperCase()}
                  {userDetail?.userSurName?.charAt(0)?.toUpperCase()}
                </Avatar>
              ) : (
                <Avatar
                  src={userDetail?.profileImage}
                  alt={
                    userDetail?.userName?.charAt(0) +
                    userDetail?.userSurName?.charAt(0)
                  }
                  sx={{
                    width: 32,
                    height: 33,
                    backgroundColor: '#666666',
                    fontFamily: 'poppins',
                    borderRadius: '35px',
                    fontSize: '15px',
                  }}
                />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      )}
      {!footer && (
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={openAcc}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 1000000,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          sx={{ zIndex: 1000000 }}
        >
          <MenuItem
            onClick={handleOpens}
            sx={
              (poppins600,
              { fontWeight: '600 !important', fontSize: '14px !important' })
            }
          >
            {userDetail?.profileImage == '' ||
            userDetail?.profileImage == null ? (
              <Avatar
                sx={{
                  width: 32,
                  height: 33,
                  fontSize: '15px',
                  fontFamily: 'poppins',
                  borderRadius: '6px',
                  backgroundColor: '#666666',
                }}
              >
                {userDetail?.userName?.charAt(0)?.toUpperCase()}
                {userDetail?.userSurName?.charAt(0)?.toUpperCase()}
              </Avatar>
            ) : (
              <Avatar
                src={userDetail?.profileImage}
                alt={
                  userDetail?.userName?.charAt(0) +
                  userDetail?.userSurName?.charAt(0)
                }
                sx={{
                  width: 32,
                  height: 33,
                  backgroundColor: '#666666',
                  borderRadius: '32px',
                }}
              />
            )}
            Profile
          </MenuItem>

          {userDetail?.qrCodeValue && (
            <MenuItem
              sx={
                (poppins600,
                {
                  fontWeight: '600 !important',
                  fontSize: '14px !important',
                  padding: '12px 10px 13px 16px',
                })
              }
              onClick={async () => {
                await setOpenGen(true);
              }}
            >
              <ListItemIcon>
                <QrCode fontSize="medium" />
              </ListItemIcon>
              QR Code
            </MenuItem>
          )}
          {userDetail?.primaryUserType !== 'Agent' &&
            CheckSolicitor == 'no' &&
            userDetail?.primaryUserType !== 'Solicitor' &&
            userDetail?.primaryUserType !== 'Vendor' && (
              <MenuItem
                onClick={() => {
                  setOpen(!open);
                }}
                sx={
                  (poppins600,
                  {
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: '600 !important',
                    fontSize: '14px !important',
                  })
                }
              >
                <SvgIcon
                  fontSize="large"
                  style={{
                    paddingRight: '8px',
                    marginBottom: '5px',
                    color: '#000000',
                  }}
                >
                  <AddUser />
                </SvgIcon>
                <span style={{ paddingRight: '4px' }}>Solicitor</span>
              </MenuItem>
            )}

          <MenuItem
            sx={
              (poppins600,
              {
                fontWeight: '600 !important',
                fontSize: '14px !important',
                padding: '12px 0px 13px 17px',
              })
            }
            onClick={() => {
              history.push('/logout');
              handleClose();
            }}
          >
            <ListItemIcon>
              <Logout fontSize="medium" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      )}
      {footer && colseAccountItem && (
        <Grid
          container
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            mt: '15px',
          }}
        >
          <Grid
            item
            onClick={() => {
              handleMenuToggle();
              setColseAccountItem(!colseAccountItem);
            }}
            sx={{
              width: '100%',
              padding: '13px',
              fontWeight: '600 !important',
              fontFamily: 'poppins',
              fontSize: '14px !important',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              pl: '20px',
            }}
          >
            <ListItemIcon>
              <Avatar
                sx={{
                  width: 25,
                  height: 25,
                  backgroundColor: '#666666',
                  borderRadius: '6px',
                }}
              >
                <Typography
                  fontWeight={500}
                  color="#FFFFFF"
                  fontFamily="Poppins"
                  fontSize="14px"
                >
                  {userDetail?.userName?.toUpperCase()}
                  {userDetail?.userSurName?.toUpperCase()}
                </Typography>
              </Avatar>
            </ListItemIcon>
            Profile
          </Grid>
          <Divider sx={{ borderTop: '1px solid #DCE0E0', width: '100%' }} />
          {userDetail?.qrCodeValue && (
            <Grid
              item
              sx={{
                width: '100%',
                padding: '13px',
                fontWeight: '600 !important',
                fontFamily: 'poppins',
                fontSize: '14px !important',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                pl: '20px',
              }}
              onClick={async () => {
                await setOpenGen(true);
                setColseAccountItem(!colseAccountItem);
              }}
            >
              <ListItemIcon>
                <QrCode />
              </ListItemIcon>
              QR Code
            </Grid>
          )}
          <Divider sx={{ borderTop: '1px solid #DCE0E0', width: '100%' }} />
          {userDetail?.primaryUserType !== 'Agent' &&
            CheckSolicitor == 'no' &&
            userDetail?.primaryUserType !== 'Solicitor' &&
            userDetail?.primaryUserType !== 'Vendor' && (
              <>
                <Grid
                  item
                  onClick={() => {
                    setOpen(!open);
                    setColseAccountItem(!colseAccountItem);
                  }}
                  sx={{
                    display: 'flex',
                    width: '100%',
                    padding: '13px',
                    alignItems: 'center',
                    fontFamily: 'poppins',
                    fontWeight: '600 !important',
                    fontSize: '14px !important',
                    pl: '20px',
                  }}
                >
                  <ListItemIcon
                    fontSize="large"
                    style={{
                      paddingRight: '10px',
                      marginBottom: '5px',
                      color: '#000000',
                    }}
                  >
                    <AddUser />
                  </ListItemIcon>
                  <span>Solicitor</span>
                </Grid>
                <Divider
                  sx={{ borderTop: '1px solid #DCE0E0', width: '100%' }}
                />
              </>
            )}
          <Grid
            item
            sx={{
              width: '100%',
              padding: '13px',
              fontWeight: '600 !important',
              fontFamily: 'poppins',
              fontSize: '14px !important',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              pl: '20px',
            }}
            onClick={() => {
              history.push('/logout');
              handleMenuToggle();
            }}
          >
            <ListItemIcon>
              <Logout fontSize="medium" />
            </ListItemIcon>
            Logout
          </Grid>
          <Divider sx={{ borderTop: '1px solid #DCE0E0', width: '100%' }} />
        </Grid>
      )}
      <QrCodeGenerator
        setOpenGen={setOpenGen}
        openGen={openGen}
        value={userDetail?.qrCodeValue}
        userAppId={userDetail?.userAppId?.replace(/^([A-Za-z])[A-Za-z]*/, '$1')}
      />
      {open && (
        <BasicModal
          open={open}
          setOpen={setOpen}
          dashboard={true}
          propertyId={propertyId}
          opensolicitor={opensolicitor}
          setOpensolicitor={setOpensolicitor}
        />
      )}
    </React.Fragment>
  );
}
